import React from 'react';
import { useAppContext } from 'Context/ReactAppContext';
import { get } from 'lodash';
import { ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION } from 'Components/utils/identifiers/constants';
import { Modal } from 'Components/frameworks/modal/Modal';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Button } from 'Components/frameworks/button/Button';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
type Props = {
  i18n: {};
  closeModal: () => any;
  newAccount?: string;
  persistenceExtended?: boolean;
};
export const SaveCriteriaConfirmation = ({
  i18n,
  closeModal,
  newAccount,
  persistenceExtended,
}: Props) => {
  const { isCmta } = useAppContext();
  const { dataProtectionPolicyUrl, dataProtectionPolicyLabel } = get(
    i18n,
    'booking.saveMyCriteria',
    {},
  );

  const getModalTitle = () => {
    if (isCmta) {
      return get(
        i18n,
        persistenceExtended
          ? 'booking.saveMyProposal.seller.saveConfirmation'
          : 'booking.saveMyProposal.seller.unsaveConfirmation',
      );
    }

    return newAccount
      ? get(i18n, 'booking.saveMyCriteria.saveConfirmationNewAccount')
      : get(i18n, 'booking.saveMyCriteria.saveConfirmation');
  };

  const legalInfos = isCmta
    ? get(i18n, 'booking.saveMyProposal.seller.info')
    : get(i18n, 'booking.saveMyCriteria.legalInfo');
  return (
    <Modal
      ariaLabel={getModalTitle()}
      ariaLabelledby={ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION}
      closeLabel={get(i18n, 'common.close')}
      onClose={closeModal}
      size="small"
    >
      <div
        className="overflow-hidden bg-white px-50 py-20 text-center"
        data-testid="SaveCriteriaLogin--confirmation"
      >
        <div>
          <Icon className="text-success" name={ICONS.CHECK} width="3rem" />
        </div>
        <div
          className="w-full text-center text-22 font-bold text-black"
          data-testid="SaveCriteria-confirmation"
          id={ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION}
        >
          {getModalTitle()}
        </div>
        <div>
          <Button className="mb-15 mt-50 min-w-[250px]" onClick={closeModal}>
            {get(i18n, 'booking.saveMyCriteria.continue')}
          </Button>
        </div>
        {!isCmta && (
          <DynamicLink
            className="m-auto flex items-center justify-center text-16 font-bold text-black hocus:text-black-active"
            data-selector="SaveCriteria-link"
            target="_blank"
            url="/account"
          >
            {get(i18n, 'booking.saveMyCriteria.accessAccount')}
            <Icon hasRtl name={ICONS.ARROW_RIGHT} width="1rem" />
          </DynamicLink>
        )}
        <div className="mt-30 flex flex-col items-center" data-testid="SaveCriteria-popinLegalInfo">
          {isCmta && persistenceExtended && <p className="w-full text-center">{legalInfos}</p>}
          {!isCmta && (
            <DynamicLink className="text-inherit underline" url={dataProtectionPolicyUrl}>
              {dataProtectionPolicyLabel}
            </DynamicLink>
          )}
        </div>
      </div>
    </Modal>
  );
};
